import handlePromise from 'utils/handle-promise'

export async function createCommentService({
  course_slug, lesson_slug, token, comment, parent,
}) {
  const url = `/api/v1/courses/${course_slug}/lessons/${lesson_slug}/comments/`
  const payload = {
    parent: parent || null,
    content: {
      ...comment,
    },
  }
  const data = await handlePromise(url, {
    method: 'POST',
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })
  return data
}

export async function deleteCommentService({
  token, commentId,
}) {
  const url = `/api/v1/comments/${commentId}`
  const data = await handlePromise(url, {
    method: 'DELETE',
    headers: {
      Authorization: token,
    },
  })
  return data
}

// TODO: RES
export async function getCommentsService({
  course, lesson_slug, token, res, req, featured,
}) {
  const query = featured ? `?featured=${featured}` : ''
  const url = `/api/v1/courses/${course}/lessons/${lesson_slug}/comments/${query}`
  const data = await handlePromise(url, {
    headers: { Authorization: token || '' },
  })
  return data
}

export async function getRepliesService({
  course, lesson_slug, parent, token,
}) {
  const url = `/api/v1/courses/${course}/lessons/${lesson_slug}/comments/?parent=${parent}`
  const data = await handlePromise(url, {
    headers: { Authorization: token || '' },
  })
  return data.results
}

// TODO DELETE THIS QITH REACT QUERY
export async function getRepliesListByIdService({
  course_slug, lesson_slug, parent, token,
}) {
  const url = `/api/v1/courses/${course_slug}/lessons/${lesson_slug}/comments/?parent=${parent}`
  const data = await handlePromise(url, {
    headers: { Authorization: token || '' },
  })
  return data.results
}

export async function getNextCommentsService({ next, token }) {
  const url = next.slice(next.search('/api/v1'))
  const data = await handlePromise(url, {
    headers: { Authorization: token || '' },
  })
  return data
}

export async function reactToCommentService({
  course, lesson_slug, token, payload,
}) {
  const url = `/api/v1/courses/${course}/lessons/${lesson_slug}/reactions/`
  const data = await handlePromise(url, {
    headers: { Authorization: token, 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify(payload),
  })
  const { like, wand, nogiveup } = data

  return { like, wand, nogiveup }
}

// TODO DELETE THIS QITH REACT QUERY
export async function reactToACommentService({
  course_slug, lesson_slug, token, payload,
}) {
  const url = `/api/v1/courses/${course_slug}/lessons/${lesson_slug}/reactions/`
  const data = await handlePromise(url, {
    headers: { Authorization: token, 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify(payload),
  })
  const { like, wand, nogiveup } = await data

  return { like, wand, nogiveup }
}

export async function getUsersService({ username, token }) {
  const url = `/api/v1/users/?username=${username}`
  const data = await handlePromise(url, {
    headers: { Authorization: token || '' },
  })
  return data
}
